import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { PayoutResult } from 'src/app/services/multi-claim-calculator-service';

@Component({
  selector: 'app-apg-benefit-payments',
  templateUrl: './apg-benefit-payments.component.html',
  styleUrls: ['./apg-benefit-payments.component.scss'],
})
export class ApgBenefitPaymentsComponent implements OnInit {
  @Input('results') results: PayoutResult;
  payout: any[];
  totalBenefit: number;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['results']) {
      this.payout = this.transform(this.results);
      this.totalBenefit = this.results.payouts.reduce((sum, current) => sum + current.payout, 0);
    }
  }

  ngOnInit() {
  }

  transform(results: PayoutResult) {
    let list: any[] = [];
    results.payouts.forEach(x =>
    (list.push({
      payout: x.payout,
      condition: x.group
    })));
    return list;
  }
}
